import React from 'react';

export default function CallBtn({ onClick, active, danger, title, children, large }) {
  const size = large ? 36 : 24;
  return (
    <button
      onClick={onClick}
      title={title}
      style={{
        width: size, height: size, borderRadius: '50%', border: 'none',
        background: danger ? '#ef4444' : active !== false ? 'rgba(255,255,255,0.15)' : '#ef4444',
        color: '#fff', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, transition: 'background 0.15s',
      }}
    >
      {children}
    </button>
  );
}
